/**
 * Add a schema to a url with an ambiguous schema (`//`) (default is `https`).
 *
 * ```
 * ensureSchema('//cdn.invitae.com/i/123') === 'https://cdn.invitae.com/i/123'
 * ```
 */
var ensureSchema = function (url, schema) {
    if (schema === void 0) { schema = 'https'; }
    if (url)
        return url.startsWith('//') ? "".concat(schema, ":").concat(url) : url;
    return '';
};
/**
 * Construct a URL query string from a given object.
 */
var queryStringFrom = function (params) {
    return Object.entries(params)
        .map(function (parts) { return parts.map(encodeURIComponent).join('='); })
        .join('&');
};
/**
 * Add a query parameter to a given URL to make Contentful return the image as a JPG.
 */
var ensureCorrectPreviewImageUrl = function (url) { return "".concat(url, "?").concat(queryStringFrom({ fm: 'jpg' })); };

export { ensureCorrectPreviewImageUrl, ensureSchema, queryStringFrom };
//# sourceMappingURL=utils.esm.js.map
